import styled from 'styled-components';
import PillButton from 'components/buttons/PillButton';

export const DestinationGrid = styled.div`
  ${({ showImage, gap }) =>
    showImage
      ? `
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 1fr 1fr;
    `
      : `
    display: flex;
    gap: ${gap};
    flex-wrap: wrap;
  `}

  width: 100%;
`;

export const CurrentOptionsWrap = styled.div`
  width: 100;
  height: 100%;
`;

export const Button = styled(PillButton)`
  margin-left: 5px;
`;

export const Section = styled.div``;

export const Wrapper = styled.div`
  margin-bottom: 25px;
  max-width: 1000px;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  button {
    margin-right: 8px;
    margin-bottom: 10px;
    flex-shrink: 0;
  }
`;